import {createAsyncThunk} from '@reduxjs/toolkit';
import axios from 'axios';
import {showMessage} from 'app/store/fuse/messageSlice';
import {BACKEND_SCHEDULER_URL} from 'app/main/constants/serverConstants';
import {GET_REOCCURRING_CONFIG_DETAILS, RECURRING_CONFIG_PAGINATED, REOCCURRING_CONFIG} from './urls';
import {processReoccurringConfig} from './processTaskItems';
// eslint-disable-next-line import/no-cycle
import { setReloadGrid } from '../taskBoardGridSlice';

export const getReoccurring = createAsyncThunk(
	'taskBoardApp/taskBoardGrid/getReoccurring',
	async (params, thunkApi) => {
		try {
			const {data: reoccurringData, metaData} = (
				await axios.get(`${BACKEND_SCHEDULER_URL}${RECURRING_CONFIG_PAGINATED}`, {params})
			).data;
			const technicians = thunkApi.getState()?.schedulerCommon?.schedulerCommon?.technicians;
			const busEntityIdMap = thunkApi.getState()?.schedulerCommon?.schedulerCommon?.businessEntityIdMap;
			const sampleLocIdMap = thunkApi.getState()?.schedulerCommon?.schedulerCommon?.sampleLocationIdMap;
			const locationIdMap = thunkApi.getState()?.schedulerCommon?.schedulerCommon?.locationIdMap;
			const newTasks = processReoccurringConfig(reoccurringData, technicians, sampleLocIdMap, busEntityIdMap, locationIdMap);
			return {tasks: newTasks, metaData};
		} catch (err) {
			console.warn(err);
			return thunkApi.rejectWithValue('Something went wrong. Please try again!');
		}
	}
);

export const getReoccurringById = createAsyncThunk(
	'taskBoardApp/taskBoardGrid/getReoccurringById',
	async (reccId, thunkApi) => {
		try {
			const task = (await axios.get(`${BACKEND_SCHEDULER_URL}${GET_REOCCURRING_CONFIG_DETAILS}/${reccId}`)).data;
			return task;
		} catch (err) {
			console.warn(err);
			return thunkApi.rejectWithValue('Something went wrong. Please try again!');
		}
	}
);

export const createReoccurring = createAsyncThunk(
	'taskBoardApp/taskBoardGrid/createReoccurring',
	async (params, thunkApi) => {
		try {
			const task = (await axios.post(`${BACKEND_SCHEDULER_URL}${REOCCURRING_CONFIG}`, params)).data;
			thunkApi.dispatch(setReloadGrid());
			thunkApi.dispatch(showMessage({message: 'Reoccurring config created successfully', variant: 'success'}));
			return task;
		} catch (err) {
			thunkApi.dispatch(showMessage({message: `${err}`, variant: 'error'}));
			return thunkApi.rejectWithValue('Something went wrong. Please try again!');
		}
	}
);

export const updateReoccurring = createAsyncThunk(
	'taskBoardApp/taskBoardGrid/updateReoccurring',
	async (params, thunkApi) => {
		try {
			const task = (await axios.put(`${BACKEND_SCHEDULER_URL}${REOCCURRING_CONFIG}/${params.id}`, params)).data;
			thunkApi.dispatch(showMessage({message: 'Reoccurring config updated successfully', variant: 'success'}));
			thunkApi.dispatch(setReloadGrid());
			return task;
		} catch (err) {
			thunkApi.dispatch(showMessage({message: `${err}`, variant: 'error'}));
			return thunkApi.rejectWithValue('Something went wrong. Please try again!');
		}
	}
);

export const deleteReoccurring = createAsyncThunk(
	'taskBoardApp/taskBoardGrid/deleteReoccurring',
	async (configId, thunkApi) => {
		try {
			const response = await axios.delete(`${BACKEND_SCHEDULER_URL}${REOCCURRING_CONFIG}/${configId}`);
			let id = null;
			if (response.status === 200) {
				id = configId;
				thunkApi.dispatch(setReloadGrid());
				thunkApi.dispatch(
					showMessage({message: 'Reoccurring Config deleted Successfully', variant: 'success'})
				);
			}
			return id;
		} catch (err) {
			thunkApi.dispatch(showMessage({message: `${err}`, variant: 'error'}));
			return thunkApi.rejectWithValue('Something went wrong. Please try again!');
		}
	}
);

export const updateReoccurringStatus = createAsyncThunk(
	'taskBoardApp/taskBoardGrid/updateReoccurringStatus',
	async (params, thunkApi) => {
		try {
			await axios.put(`${BACKEND_SCHEDULER_URL}${REOCCURRING_CONFIG}/${params.id}/status`, params);
			thunkApi.dispatch(setReloadGrid());
			thunkApi.dispatch(
				showMessage({
					message: `${params.isActive ? 'Enabled' : 'Disabled'} Reoccurring Successfully`,
					variant: 'success'
				})
			);
			return params;
		} catch (err) {
			thunkApi.dispatch(showMessage({message: `${err}`, variant: 'error'}));
			return thunkApi.rejectWithValue('Something went wrong. Please try again!');
		}
	}
);
